"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebLoginResponse = exports.WebLoginRequest = exports.WebLoginResponse_StatusCode = void 0;
/* eslint-disable */
const web_login_common_1 = require("./web_login_common");
const challenge_orchestration_common_1 = require("./challenge_orchestration_common");
const challenge_orchestration_challenge_data_1 = require("./challenge_orchestration_challenge_data");
const tivs_1 = require("../../auth/tivs/tivs");
const uuid_1 = require("../../core/uuid");
const web_login_bootstrap_1 = require("./web_login_bootstrap");
const login_common_1 = require("./login_common");
const minimal_1 = __importDefault(require("protobufjs/minimal"));
/** Describes what happened with the request. */
var WebLoginResponse_StatusCode;
(function (WebLoginResponse_StatusCode) {
    /** UNSET - default value */
    WebLoginResponse_StatusCode[WebLoginResponse_StatusCode["UNSET"] = 0] = "UNSET";
    /** SUCCESS - Login success. There were no more challenges issued. Authentication Assurance Level (AAL) >= Enforced Authentication Assurance Requirement (EAAR). */
    WebLoginResponse_StatusCode[WebLoginResponse_StatusCode["SUCCESS"] = 1] = "SUCCESS";
    /** CHALLENGED - There were additional challenges issued. There is no guarantee that the provided challenge answer was correct. */
    WebLoginResponse_StatusCode[WebLoginResponse_StatusCode["CHALLENGED"] = 2] = "CHALLENGED";
    /** ACCOUNT_DEACTIVATED - The user's account is deactivated. Accounts in this state will be deleted after 30 days, unless user reactivates. */
    WebLoginResponse_StatusCode[WebLoginResponse_StatusCode["ACCOUNT_DEACTIVATED"] = 3] = "ACCOUNT_DEACTIVATED";
    /** ACCOUNT_LOCKED - The user's account is locked. User would need to unlock their account before logging in */
    WebLoginResponse_StatusCode[WebLoginResponse_StatusCode["ACCOUNT_LOCKED"] = 4] = "ACCOUNT_LOCKED";
    /**
     * ERR_GENERIC_FAILURE - Generic failure for backwards compatability of any new error types we add in future
     * client should not auto-retry, but can allow the user to retry
     */
    WebLoginResponse_StatusCode[WebLoginResponse_StatusCode["ERR_GENERIC_FAILURE"] = 9] = "ERR_GENERIC_FAILURE";
    /**
     * ERR_THROTTLED - the request was throttled by the service
     * client should not auto-retry but can retry the request
     */
    WebLoginResponse_StatusCode[WebLoginResponse_StatusCode["ERR_THROTTLED"] = 10] = "ERR_THROTTLED";
    /**
     * ERR_ACCOUNT_NOT_FOUND - a user was not found with the provided identifier
     * client should require user to reenter identifier before retry
     */
    WebLoginResponse_StatusCode[WebLoginResponse_StatusCode["ERR_ACCOUNT_NOT_FOUND"] = 11] = "ERR_ACCOUNT_NOT_FOUND";
    /**
     * ERR_FAILED_CHALLENGE - the challenge answer provided by the user is incorrect.
     * client should require user to reenter the challenge answer before retry
     */
    WebLoginResponse_StatusCode[WebLoginResponse_StatusCode["ERR_FAILED_CHALLENGE"] = 12] = "ERR_FAILED_CHALLENGE";
    /**
     * ERR_BLOCKED - login is not allowed on this device, ip, or other reason
     * client can let user retry, but unlikely it will succeed
     */
    WebLoginResponse_StatusCode[WebLoginResponse_StatusCode["ERR_BLOCKED"] = 13] = "ERR_BLOCKED";
    /**
     * ERR_DENIED - the login request denied due to too many failures.
     * client can let user retry, but unlikely it will succeed
     */
    WebLoginResponse_StatusCode[WebLoginResponse_StatusCode["ERR_DENIED"] = 14] = "ERR_DENIED";
    WebLoginResponse_StatusCode[WebLoginResponse_StatusCode["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(WebLoginResponse_StatusCode = exports.WebLoginResponse_StatusCode || (exports.WebLoginResponse_StatusCode = {}));
function createBaseWebLoginRequest() {
    return {
        webLoginHeader: undefined,
        loginIdentifier: undefined,
        unavailableChallenges: undefined,
        challengeAnswer: undefined,
        platformRequestData: undefined,
        webLoginHeaderBrowser: undefined,
    };
}
exports.WebLoginRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.webLoginHeader !== undefined) {
            web_login_common_1.WebLoginHeader.encode(message.webLoginHeader, writer.uint32(10).fork()).ldelim();
        }
        if (message.loginIdentifier?.$case === "username") {
            writer.uint32(18).string(message.loginIdentifier.username);
        }
        if (message.loginIdentifier?.$case === "email") {
            writer.uint32(26).string(message.loginIdentifier.email);
        }
        if (message.loginIdentifier?.$case === "phoneNumber") {
            writer.uint32(34).string(message.loginIdentifier.phoneNumber);
        }
        if (message.unavailableChallenges !== undefined) {
            challenge_orchestration_common_1.UnavailableChallenges.encode(message.unavailableChallenges, writer.uint32(42).fork()).ldelim();
        }
        if (message.challengeAnswer !== undefined) {
            challenge_orchestration_challenge_data_1.ChallengeAnswer.encode(message.challengeAnswer, writer.uint32(50).fork()).ldelim();
        }
        if (message.platformRequestData !== undefined) {
            tivs_1.PlatformRequestData.encode(message.platformRequestData, writer.uint32(58).fork()).ldelim();
        }
        if (message.webLoginHeaderBrowser !== undefined) {
            web_login_common_1.WebLoginHeaderFromBrowser.encode(message.webLoginHeaderBrowser, writer.uint32(66).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWebLoginRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.webLoginHeader = web_login_common_1.WebLoginHeader.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.loginIdentifier = {
                        $case: "username",
                        username: reader.string(),
                    };
                    break;
                case 3:
                    message.loginIdentifier = { $case: "email", email: reader.string() };
                    break;
                case 4:
                    message.loginIdentifier = {
                        $case: "phoneNumber",
                        phoneNumber: reader.string(),
                    };
                    break;
                case 5:
                    message.unavailableChallenges = challenge_orchestration_common_1.UnavailableChallenges.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.challengeAnswer = challenge_orchestration_challenge_data_1.ChallengeAnswer.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.platformRequestData = tivs_1.PlatformRequestData.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.webLoginHeaderBrowser = web_login_common_1.WebLoginHeaderFromBrowser.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseWebLoginRequest();
        message.webLoginHeader =
            object.webLoginHeader !== undefined && object.webLoginHeader !== null
                ? web_login_common_1.WebLoginHeader.fromPartial(object.webLoginHeader)
                : undefined;
        if (object.loginIdentifier?.$case === "username" &&
            object.loginIdentifier?.username !== undefined &&
            object.loginIdentifier?.username !== null) {
            message.loginIdentifier = {
                $case: "username",
                username: object.loginIdentifier.username,
            };
        }
        if (object.loginIdentifier?.$case === "email" &&
            object.loginIdentifier?.email !== undefined &&
            object.loginIdentifier?.email !== null) {
            message.loginIdentifier = {
                $case: "email",
                email: object.loginIdentifier.email,
            };
        }
        if (object.loginIdentifier?.$case === "phoneNumber" &&
            object.loginIdentifier?.phoneNumber !== undefined &&
            object.loginIdentifier?.phoneNumber !== null) {
            message.loginIdentifier = {
                $case: "phoneNumber",
                phoneNumber: object.loginIdentifier.phoneNumber,
            };
        }
        message.unavailableChallenges =
            object.unavailableChallenges !== undefined &&
                object.unavailableChallenges !== null
                ? challenge_orchestration_common_1.UnavailableChallenges.fromPartial(object.unavailableChallenges)
                : undefined;
        message.challengeAnswer =
            object.challengeAnswer !== undefined && object.challengeAnswer !== null
                ? challenge_orchestration_challenge_data_1.ChallengeAnswer.fromPartial(object.challengeAnswer)
                : undefined;
        message.platformRequestData =
            object.platformRequestData !== undefined &&
                object.platformRequestData !== null
                ? tivs_1.PlatformRequestData.fromPartial(object.platformRequestData)
                : undefined;
        message.webLoginHeaderBrowser =
            object.webLoginHeaderBrowser !== undefined &&
                object.webLoginHeaderBrowser !== null
                ? web_login_common_1.WebLoginHeaderFromBrowser.fromPartial(object.webLoginHeaderBrowser)
                : undefined;
        return message;
    },
};
function createBaseWebLoginResponse() {
    return {
        statusCode: 0,
        authenticationSessionPayload: new Uint8Array(),
        loginIdentifier: undefined,
        payload: undefined,
        userId: undefined,
    };
}
exports.WebLoginResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.statusCode !== 0) {
            writer.uint32(8).int32(message.statusCode);
        }
        if (message.authenticationSessionPayload.length !== 0) {
            writer.uint32(18).bytes(message.authenticationSessionPayload);
        }
        if (message.loginIdentifier?.$case === "username") {
            writer.uint32(26).string(message.loginIdentifier.username);
        }
        if (message.loginIdentifier?.$case === "email") {
            writer.uint32(34).string(message.loginIdentifier.email);
        }
        if (message.loginIdentifier?.$case === "phoneNumber") {
            writer.uint32(42).string(message.loginIdentifier.phoneNumber);
        }
        if (message.payload?.$case === "bootstrapData") {
            web_login_bootstrap_1.WebBootstrapData.encode(message.payload.bootstrapData, writer.uint32(50).fork()).ldelim();
        }
        if (message.payload?.$case === "challengeData") {
            challenge_orchestration_challenge_data_1.ChallengeData.encode(message.payload.challengeData, writer.uint32(58).fork()).ldelim();
        }
        if (message.payload?.$case === "accountDeactivationData") {
            login_common_1.AccountDeactivationData.encode(message.payload.accountDeactivationData, writer.uint32(66).fork()).ldelim();
        }
        if (message.payload?.$case === "accountLockedData") {
            login_common_1.AccountLockedData.encode(message.payload.accountLockedData, writer.uint32(74).fork()).ldelim();
        }
        if (message.payload?.$case === "errorData") {
            login_common_1.ErrorData.encode(message.payload.errorData, writer.uint32(82).fork()).ldelim();
        }
        if (message.payload?.$case === "bootstrapDataBrowser") {
            web_login_bootstrap_1.WebBootstrapDataBrowser.encode(message.payload.bootstrapDataBrowser, writer.uint32(106).fork()).ldelim();
        }
        if (message.userId !== undefined) {
            uuid_1.UUID.encode(message.userId, writer.uint32(90).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWebLoginResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.statusCode = reader.int32();
                    break;
                case 2:
                    message.authenticationSessionPayload = reader.bytes();
                    break;
                case 3:
                    message.loginIdentifier = {
                        $case: "username",
                        username: reader.string(),
                    };
                    break;
                case 4:
                    message.loginIdentifier = { $case: "email", email: reader.string() };
                    break;
                case 5:
                    message.loginIdentifier = {
                        $case: "phoneNumber",
                        phoneNumber: reader.string(),
                    };
                    break;
                case 6:
                    message.payload = {
                        $case: "bootstrapData",
                        bootstrapData: web_login_bootstrap_1.WebBootstrapData.decode(reader, reader.uint32()),
                    };
                    break;
                case 7:
                    message.payload = {
                        $case: "challengeData",
                        challengeData: challenge_orchestration_challenge_data_1.ChallengeData.decode(reader, reader.uint32()),
                    };
                    break;
                case 8:
                    message.payload = {
                        $case: "accountDeactivationData",
                        accountDeactivationData: login_common_1.AccountDeactivationData.decode(reader, reader.uint32()),
                    };
                    break;
                case 9:
                    message.payload = {
                        $case: "accountLockedData",
                        accountLockedData: login_common_1.AccountLockedData.decode(reader, reader.uint32()),
                    };
                    break;
                case 10:
                    message.payload = {
                        $case: "errorData",
                        errorData: login_common_1.ErrorData.decode(reader, reader.uint32()),
                    };
                    break;
                case 13:
                    message.payload = {
                        $case: "bootstrapDataBrowser",
                        bootstrapDataBrowser: web_login_bootstrap_1.WebBootstrapDataBrowser.decode(reader, reader.uint32()),
                    };
                    break;
                case 11:
                    message.userId = uuid_1.UUID.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseWebLoginResponse();
        message.statusCode = object.statusCode ?? 0;
        message.authenticationSessionPayload =
            object.authenticationSessionPayload ?? new Uint8Array();
        if (object.loginIdentifier?.$case === "username" &&
            object.loginIdentifier?.username !== undefined &&
            object.loginIdentifier?.username !== null) {
            message.loginIdentifier = {
                $case: "username",
                username: object.loginIdentifier.username,
            };
        }
        if (object.loginIdentifier?.$case === "email" &&
            object.loginIdentifier?.email !== undefined &&
            object.loginIdentifier?.email !== null) {
            message.loginIdentifier = {
                $case: "email",
                email: object.loginIdentifier.email,
            };
        }
        if (object.loginIdentifier?.$case === "phoneNumber" &&
            object.loginIdentifier?.phoneNumber !== undefined &&
            object.loginIdentifier?.phoneNumber !== null) {
            message.loginIdentifier = {
                $case: "phoneNumber",
                phoneNumber: object.loginIdentifier.phoneNumber,
            };
        }
        if (object.payload?.$case === "bootstrapData" &&
            object.payload?.bootstrapData !== undefined &&
            object.payload?.bootstrapData !== null) {
            message.payload = {
                $case: "bootstrapData",
                bootstrapData: web_login_bootstrap_1.WebBootstrapData.fromPartial(object.payload.bootstrapData),
            };
        }
        if (object.payload?.$case === "challengeData" &&
            object.payload?.challengeData !== undefined &&
            object.payload?.challengeData !== null) {
            message.payload = {
                $case: "challengeData",
                challengeData: challenge_orchestration_challenge_data_1.ChallengeData.fromPartial(object.payload.challengeData),
            };
        }
        if (object.payload?.$case === "accountDeactivationData" &&
            object.payload?.accountDeactivationData !== undefined &&
            object.payload?.accountDeactivationData !== null) {
            message.payload = {
                $case: "accountDeactivationData",
                accountDeactivationData: login_common_1.AccountDeactivationData.fromPartial(object.payload.accountDeactivationData),
            };
        }
        if (object.payload?.$case === "accountLockedData" &&
            object.payload?.accountLockedData !== undefined &&
            object.payload?.accountLockedData !== null) {
            message.payload = {
                $case: "accountLockedData",
                accountLockedData: login_common_1.AccountLockedData.fromPartial(object.payload.accountLockedData),
            };
        }
        if (object.payload?.$case === "errorData" &&
            object.payload?.errorData !== undefined &&
            object.payload?.errorData !== null) {
            message.payload = {
                $case: "errorData",
                errorData: login_common_1.ErrorData.fromPartial(object.payload.errorData),
            };
        }
        if (object.payload?.$case === "bootstrapDataBrowser" &&
            object.payload?.bootstrapDataBrowser !== undefined &&
            object.payload?.bootstrapDataBrowser !== null) {
            message.payload = {
                $case: "bootstrapDataBrowser",
                bootstrapDataBrowser: web_login_bootstrap_1.WebBootstrapDataBrowser.fromPartial(object.payload.bootstrapDataBrowser),
            };
        }
        message.userId =
            object.userId !== undefined && object.userId !== null
                ? uuid_1.UUID.fromPartial(object.userId)
                : undefined;
        return message;
    },
};
//# sourceMappingURL=web_login.js.map